import { render, staticRenderFns } from "./ChouQuRule.vue?vue&type=template&id=4620d82c&scoped=true&"
import script from "./ChouQuRule.vue?vue&type=script&lang=js&"
export * from "./ChouQuRule.vue?vue&type=script&lang=js&"
import style0 from "./ChouQuRule.vue?vue&type=style&index=0&id=4620d82c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4620d82c",
  null
  
)

export default component.exports